import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getInitials(name: string, maxLength: number = 2) {
  return name
    .split(' ')
    .map((s) => s[0])
    .join('')
    .slice(0, maxLength)
    .toUpperCase()
}

interface IsNumberInRangeProps {
  value: number
  min?: number
  max?: number
}
export function isNumberInRange({ value, min, max }: IsNumberInRangeProps) {
  if (!min && !max) return true
  if (min && max) {
    return value >= min && value <= max
  }
  if (min) {
    return value >= min
  }
  if (max) {
    return value <= max
  }
  return true
}

interface IsDateInRangeProps {
  value: Date
  min?: string
  max?: string
}
export function isDateInRange({ value, min, max }: IsDateInRangeProps) {
  const valueDate = new Date(value)

  const minString = `${min?.split('T')[0]}T00:00:00.000`
  const maxString = `${max?.split('T')[0]}T23:59:59.999`

  const minDate = min ? new Date(minString) : undefined
  const maxDate = max ? new Date(maxString) : undefined

  return isNumberInRange({
    value: valueDate.getTime(),
    min: minDate?.getTime(),
    max: maxDate?.getTime(),
  })
}

/**
 * Format bytes to human readable string
 */
export function formatBytes(bytes: number, decimals: number = 2): string {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}
